<template>
  <div style="width:100%">
    <ListReminders :showOn="'excluded'" :excludeType="'customers'"></ListReminders>
  </div>
</template>

<script>
import ListReminders from "@/components/reminders/ListReminders"
export default {
  name: "ExcludedCustomers",
  components: {
    ListReminders
  },
  data: () => ({
    message: '',
    selected: [],
    dialogActive: false,
    excludeAll: false,
    forInclude: [],
    clickDialog: false,
    clickData: [],
  }),
  filters: {
    currency: function (value) {
      if (!value) return '';
      return `$${parseFloat(value).toFixed(2)}`;
    }
  },
  methods: {
    cancel () {
      this.dialogActive = false;
    },
    selectAll () {
      this.includeAll = !this.includeAll;
      this.reminders.forEach(element => {
        element.include = this.includeAll;
      });
    },
    showDetails (item) {
      this.clickData = Object.entries(item);
      this.clickDialog = !this.clickDialog;
    }
  },
  computed: {
    anySelected () {
      return this.reminders.some(x => x.include);
    }
  },

}
</script>

<style lang="scss" scoped>
</style>